import React from "react";
import { Flex } from "antd";
import useBlockFormat from "../../hooks/useBlockFormat";

import { BlockFormatMenuProps } from "../../types";

const BlockFormatMenu: React.FC<BlockFormatMenuProps> = ({ blockType }) => {
  const { blocks } = useBlockFormat({ blockType });

  const handleButtonClick = (selectedBlock: any) => {
    selectedBlock.onClick();
  };

  return (
    <Flex gap={16}>
      {blocks.map((option, index) => (
        <Flex
          key={index}
          onClick={() => handleButtonClick(option)}
          style={{ height: 16 }}
        >
          {option.icon}
        </Flex>
      ))}
    </Flex>
  );
};

export default BlockFormatMenu;
